module.exports = __webpack_public_path__ + "static/media/vcas-icon.57a0c9ca.svg";